import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import "./MainHeader.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { MobileSidebar } from "../Sidebar/SidebarMobile";
import { selectProfileImageUrl } from "../../../store/profileImageSlice.js";
import { getSherpaReturnPath } from "../../../utils/guidanceNavigation.js";

export const MainHeader = ({
  titleText,
  subtitleText,
  back,
  searchF,
  searchValue,
  onSearchChange,
  searchPlaceholder = "Search",
}) => {
  const title = titleText || "Title";
  const subtitle = subtitleText || "Sub Title";
  const navigate = useNavigate();
  const location = useLocation();
  const searchFunction = searchF || (() => {});
  const avatarUrl = useSelector(selectProfileImageUrl);

  const [sidebarOpen, setSidebarOpen] = useState(false);

  //Modifies back button behaviour based on current page.
  const handleBackButton = async () => {
    const sherpaReturnPath = getSherpaReturnPath(location.state);

    if (typeof back === "function") {
      back();
    } else if (typeof back === "string") {
      navigate(back);
    } else if (typeof back === "number") {
      navigate(back);
    } else if (location.pathname.startsWith("/live")) {
      navigate("/live");
    } else if (location.pathname === "/user-statistics") {
      navigate("/home");
    } else if (location.pathname.includes("/exercises")) {
      navigate(sherpaReturnPath || "/mindfulness", {
        replace: Boolean(sherpaReturnPath),
      });
    } else if (location.pathname.includes("/profile/")) {
      navigate("/profile");
    } else if (location.pathname.includes("/admin/")) {
      navigate("/admin");
    } else if (location.pathname.startsWith("/dev/") || location.pathname.includes("/dev/")) {
      if (window.history.state && window.history.state.idx > 0) {
        navigate(-1);
      } else {
        navigate("/dev");
      }
    } else if (location.pathname === "/dev") {
      if (window.history.state && window.history.state.idx > 0) {
        navigate(-1);
      } else {
        navigate("/home");
      }
    } else if (location.pathname === "/assessment-analytics") {
      if (window.history.state && window.history.state.idx > 0) {
        navigate(-1);
      } else {
        navigate("/dev");
      }
    } else if (window.history.state && window.history.state.idx > 0) {
      navigate(-1);
    } else {
      navigate("/user-statistics"); // Fallback: Navigate to User Statistics page (note: /home is now the TourLanding page)
    }
  };

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  //Clears Search bar on Focus
  const clearSearchBar = async () => {
    if (searchValue !== undefined) return;
    const currentText = document.getElementById("searchbar")?.value;
    if (currentText === "Search") {
      document.getElementById("searchbar").value = "";
    }
  };

  //If no text in search bar and unfocus, replace with "Search"
  const resetSearch = async () => {
    if (searchValue !== undefined) return;
    const currentText = document.getElementById("searchbar")?.value;
    if (currentText === "") {
      document.getElementById("searchbar").value = "Search";
    }
  };

  //Hide searchbar if not in mindfulness page
  useEffect(() => {
    const searchDiv = document.getElementById("searchDiv");
    if (searchDiv && location.pathname !== "/mindfulness" && location.pathname !== "/live") {
      searchDiv.style.display = "none";
    } else if (searchDiv) {
      searchDiv.style.display = "";
    }
  }, [location.pathname]);

  const showBackButton =
    back !== false &&
    back !== null &&
    location.pathname !== "/home" &&
    location.pathname !== "/live";

  return (
    <div className="header-container">
      {sidebarOpen ? <MobileSidebar /> : ""}
      <div className="header-backbutton-wrapper">
        {showBackButton && (
          <div className="header-backbutton" onClick={handleBackButton}>
            <FontAwesomeIcon icon={faChevronLeft} />
          </div>
        )}
        <div
          className="header-hamburger"
          id="hamburger"
          onClick={toggleSidebar}
        >
          <FontAwesomeIcon icon={faBars} />
        </div>
      </div>
      <div className="header-content-wrapper">
        {location.pathname.includes("/profile") && (
          <div className="profile-picture-container">
            <img
              className="profile-icon"
              alt="Profile"
              src={avatarUrl || "/pro.png"}
              onError={(e) => {
                const img = e.currentTarget;
                img.onerror = null;
                img.src = "/pro.png";
              }}
            />
          </div>
        )}
        <div className="header-text-wrapper">
          <div className="header-title">
            <p>{title}</p>
          </div>
          <div className="header-subtitle">
            <p>{subtitle}</p>
          </div>
        </div>
      </div>
      <div className="header-searchbar-wrapper" id="searchDiv">
        <div className="header-searchbar-content-wrapper">
          <div className="header-searchbar-icon">
            <FontAwesomeIcon icon={faMagnifyingGlass} />
          </div>
          <div className="header-searchbar-input-box">
            <input
              type="text"
              className="header-searchbar-input"
              placeholder={searchPlaceholder}
              value={searchValue !== undefined ? searchValue : undefined}
              defaultValue={searchValue === undefined ? "Search" : undefined}
              id="searchbar"
              onBlur={resetSearch}
              onFocus={clearSearchBar}
              onChange={(e) => {
                if (onSearchChange) onSearchChange(e.target.value);
                if (searchF) searchF(e);
              }}
              onKeyUp={searchFunction}
            />
          </div>
          {Boolean(searchValue) && (
            <button
              type="button"
              className="header-searchbar-clear"
              onClick={() => {
                if (onSearchChange) onSearchChange("");
                const el = document.getElementById("searchbar");
                if (el) el.value = "";
              }}
              title="Clear search"
            >
              <FontAwesomeIcon icon={faXmark} />
            </button>
          )}
        </div>
      </div>
    </div>
  );
};
